<section class="conversation-panel" aria-label="Active conversation">
  <div class="conversation-panel__loading" data-testid="conversation-panel-loading" *ngIf="loading; else contentState">
    <cwc-loader data-testid="conversation-panel-loader" size="large"></cwc-loader>
  </div>

  <ng-template #contentState>
    <div class="conversation-panel__error" data-testid="conversation-panel-error" *ngIf="error" role="alert">
      {{ 'certify.chatbot.errors.generic' | translate }}
    </div>

    <talk-to-your-data-message-list *ngIf="messages.length > 0" [messages]="messages"></talk-to-your-data-message-list>

    <div
      class="conversation-panel__empty"
      data-testid="conversation-panel-empty"
      *ngIf="messages.length === 0 && !error"
    >
      Start by selecting a suggestion or sending a message.
    </div>
  </ng-template>
</section>
